import { defineComponent as _defineComponent } from 'vue'
import { ref as _ref, computed as _computed } from 'vue';

import { watch } from 'vue';
import {
  CustomMetadataService,
  type EntityCustomMetadataDto,
  type EntityCustomMetadataEntryLabelDto,
  type GetCustomMetadataListResponseDto,
  type GetCustomMetadataResponseDto,
  type GetCustomMetadataEntryLabelValueResponseDto,
} from '@/api';
import SChip from '@/components/SChip.vue';

interface CustomMetadataLabelSelectorProps {
  metadata: GetCustomMetadataListResponseDto;
  entityCustomMetadata?: EntityCustomMetadataDto;
}
type CustomMetadataLabelSelectorEmits = {
  (event: 'update', metadataId: string, entries: EntityCustomMetadataEntryLabelDto[]): void,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CustomMetadataLabelSelector',
  props: {
  metadata: null,
  entityCustomMetadata: null
},
  emits: ["update"],
  setup(__props, { emit: emits }) {

const props = __props;




let loading = _ref<boolean>(false);
// Local v-model proxy
let selectedEntries = _ref<string[] | string | null>([]);
let fetchedMetadata = _ref<GetCustomMetadataResponseDto>();
let searchString = _ref<string>('');

const allowMultiple = _computed(() => {
  if (fetchedMetadata.value) {
    return fetchedMetadata.value.isAllowMultipleValues;
  }
  return false;
});

const selectorItems = _computed(() => {
  if (fetchedMetadata.value) {
    return fetchedMetadata.value.entries.data as GetCustomMetadataEntryLabelValueResponseDto[];
  }
  return [];
});

/**
 * Get details on the custom metadata
 * @param metadataId
 */
const fetchMetadataInfos = async (metadataId: string) => {
  loading.value = true;
  fetchedMetadata.value = await CustomMetadataService.getCustomMetadata({ id: metadataId });
  loading.value = false;
};

/**
 * Handle selector update
 * Re-map selected entries so we also get type, ID and value from the fetched metadata on emitted change
 * @param newSelectedEntries
 */
const onSelectorUpdate = (newSelectedEntries: string[]) => {
  const entries = Array.isArray(newSelectedEntries) ? newSelectedEntries : [newSelectedEntries];
  const selectedEntriesWithValues: EntityCustomMetadataEntryLabelDto[] = entries
    .map((entryId) => selectorItems.value.find((item) => item.id === entryId) as EntityCustomMetadataEntryLabelDto | undefined)
    .filter((entry): entry is EntityCustomMetadataEntryLabelDto => entry !== undefined);
  emits('update', props.metadata.id, selectedEntriesWithValues);
  searchString.value = '';
};

watch(() => props.metadata, (newMetadata) => {
  if (newMetadata) {
    fetchMetadataInfos(newMetadata.id);
  }
}, { immediate: true });

// Pre-set selected entries based on the entity custom metadata
watch([() => props.entityCustomMetadata, () => allowMultiple.value], ([newEntityCustomMetadata, newAllowMultiple]) => {
  if (newEntityCustomMetadata) {
    if (newAllowMultiple) {
      selectedEntries.value = newEntityCustomMetadata.entries.map((entry) => entry.id);
    } else {
      // Metadata cannot be multiple: only take first entry
      const [firstEntry] = newEntityCustomMetadata.entries as GetCustomMetadataEntryLabelValueResponseDto[];
      selectedEntries.value = firstEntry?.id || null;
    }
  }
}, { immediate: true });


return { __sfc: true,props, emits, loading, selectedEntries, fetchedMetadata, searchString, allowMultiple, selectorItems, fetchMetadataInfos, onSelectorUpdate, _ref, _computed, watch, CustomMetadataService, SChip }
}

})